
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-57ac158e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ApproveSalary.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ApproveSalary.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-57ac158e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ApproveSalary.vue"),
  /* scopeId */
  "data-v-57ac158e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Approvals/ApproveSalary.vue
// module id = 688
// module chunks = 0